import { MagnifyingGlassIcon } from '@radix-ui/react-icons';
import { Box, Button, Flex, Grid } from '@radix-ui/themes';
import { NotifyHelper } from 'classes/helpers/notify.helper';
import { ErrorBoundary } from 'components/common/error-boundary';
import { CommonDateRangeInput } from 'components/common/form/date/range';
import { CommonTextInput } from 'components/common/form/text';
import { SelectHitterDataSource } from 'components/common/hitters/select-hitter-data-source';
import { SelectHitterLevel } from 'components/common/hitters/select-hitter-level';
import { SelectHitterRosterStatus } from 'components/common/hitters/select-hitter-roster-status';
import { SelectHitterSide } from 'components/common/hitters/select-hitter-side';
import { endOfDay, parseISO, startOfDay } from 'date-fns';
import { t } from 'i18next';
import { LOCAL_DATEPICKER_FORMAT } from 'lib_ts/enums/datetime.enums';
import { RADIX } from 'lib_ts/enums/radix-ui';
import useHittersStore from 'stores/use-hitters-store';

export const HitterLibraryFiltersNew = () => {
  const loading = useHittersStore((s) => s.loading);
  const currPeriod = useHittersStore((s) => s.usageFilters.currPeriod);
  const hitterFilters = useHittersStore((s) => s.hitterFilters);

  return (
    <ErrorBoundary identifier="HitterLibraryFilters">
      <Flex gap={RADIX.FLEX.GAP.SM}>
        <Box flexGrow="1">
          <CommonDateRangeInput
            id="currPeriod"
            displayFormat={LOCAL_DATEPICKER_FORMAT}
            defaultStartValue={
              currPeriod?.start ? parseISO(currPeriod.start) : undefined
            }
            defaultEndValue={
              currPeriod?.end ? parseISO(currPeriod.end) : undefined
            }
            onChange={(values) => {
              if (!values || !values.start || !values.end) {
                NotifyHelper.warning({
                  message_md: t('common.check-inputs-msg'),
                });
                return;
              }

              const currStart = startOfDay(values.start);
              const currEnd = endOfDay(values.end);

              useHittersStore.setState((prev) => ({
                usageFilters: {
                  ...prev.usageFilters,
                  currPeriod: {
                    start: currStart.toISOString(),
                    end: currEnd.toISOString(),
                  },
                },
              }));
            }}
            disabled={loading}
            onChangeOnClose
          />
        </Box>

        <Box flexGrow="1">
          <CommonTextInput
            id="filter-hitter-name"
            placeholder="hitters.player-name"
            leftSlot={<MagnifyingGlassIcon />}
            value={hitterFilters.name ?? ''}
            debounceMs={300}
            onChange={(v) =>
              useHittersStore.setState((prev) => ({
                hitterFilters: {
                  ...prev.hitterFilters,
                  name: v ?? null,
                },
              }))
            }
          />
        </Box>

        <Grid flexGrow="1" columns="4" gap={RADIX.FLEX.GAP.SM}>
          <SelectHitterSide />
          <SelectHitterLevel />
          <SelectHitterDataSource />
          <SelectHitterRosterStatus />
        </Grid>

        <Button
          variant={RADIX.BUTTON.VARIANT.SECONDARY}
          color={RADIX.COLOR.NEUTRAL}
          onClick={() => useHittersStore.getState().resetFilters()}
        >
          {t('hitters.reset-filters')}
        </Button>
      </Flex>
    </ErrorBoundary>
  );
};
